var _defs, _g, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconClickncollect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon_clickncollect_svg__cls-4{fill:#004aad}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_clickncollect_svg__clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.66 31.79H6.6c-.92 0-1.15-.32-1-1.23l2.21-18.68c.11-.9.52-1.22 1.44-1.22h1.87v3.65h1.62v-3.65h10.18v3.65h1.62v-3.65H26c.92 0 1.33.32 1.44 1.22l2.26 18.68c.11.91-.13.81-1 .81M22.92 9.44H12.74V8a5.42 5.42 0 015.09-5.09A5.42 5.42 0 0122.92 8zm8.13 22l-2.46-20.39a1.88 1.88 0 00-1.82-1.61h-2.23v-2A6.51 6.51 0 0018 .9h-.4a6.51 6.51 0 00-6.51 6.5v2H8.48a1.88 1.88 0 00-1.82 1.61L4.21 31.39A1.41 1.41 0 005.64 33h24a1.42 1.42 0 001.43-1.62",
    fill: "#c01774"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon_clickncollect_svg__cls-4",
    d: "M34.87 41.85l-5.08-5.08c-.47-.47-.95-.31-1.58.32l-.95.95c-1.27 1.27-1.9 0-1.9 0s-5.55-14.11-5.71-14.9-.16-1.42 1-.95 14.27 6.66 14.27 6.66 1 .61.31 1.27l-1.11 1.11c-1.42 1.42-.79 1.74-.79 1.74S38.2 37.25 39 38a1.1 1.1 0 010 1.59l-2.22 2.22s-1.12.83-1.91.04zM35.99 23.92h.84v2.09h-.84zM39.502 25.67l.507.67-1.666 1.262-.507-.67zM40.8 29.15v.84h-2.09v-.84zM22.44 38.41v.84h-2.09v-.84zM23.019 40.622l.55.635-1.582 1.367-.55-.636zM24.77 42.01h.84v2.09h-.84z"
  })));
}

export default SvgIconClickncollect;